export var WEBSITE_SITE_CONFIG = {
  'staging.jove.co': {
    lang: 'cn',
    country: 'CN'
  },
  'jove.co': {
    lang: 'en',
    country: 'UK'
  }
};